"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationEntity = void 0;
class NotificationEntity {
    /**
     * @deprecated
     */
    _id;
    category;
    data;
    display;
    expiration;
    from;
    id;
    media;
    campaignRequestId;
    mediaCampaign;
    message;
    read;
    subcategory;
    subject;
    to;
    createdAt;
    updatedAt;
}
exports.NotificationEntity = NotificationEntity;
